import { combineReducers } from 'redux';
import { isGridView } from './components/toggleView/toggleViewReducer';
import { selectedSort } from './components/sortDropdown/sortDropdownReducer';
import filters, * as fromFilters from './components/facetsList/facetsListReducer';
import { noResultsTemplate } from './components/noResults/noResultsReducer';
import {
  isFetching,
  showLoader,
  products,
  visiblePages,
  referrerProductId,
} from './components/productList/productListReducer';

export default combineReducers({
  filters,
  isFetching,
  showLoader,
  isGridView,
  products,
  noResultsTemplate,
  selectedSort,
  referrerProductId,
  visiblePages,
});

/*
Selectors for Redux store
TODO: analyze for advantage of using re-select library
 */
export const getValidityOfAppliedFacets = state => fromFilters.getValidityOfAppliedFacets(state.filters);
export const getTotalItems = state => state.products.totalItems;
export const getAppliedFacetIds = state => fromFilters.getAppliedFacetIds(state.filters);
export const getAppliedFacetItemIds = (state, facetId) => fromFilters.getAppliedFacetItemIds(state.filters, facetId);
export const getAllAppliedFacetItemUids = state => fromFilters.getAllAppliedFacetItemUids(state.filters);

export const getFacetById = (state, id) => fromFilters.getFullFacetData(state.filters, id);
export const getFacetItemByUid = (state, facetItemUid) => fromFilters.getFullFacetItemData(state.filters, facetItemUid);
export const getAppliedFacetsForApiQuery = state => fromFilters.getAppliedFacetsForApiQuery(state.filters);
export const computeUrlHashForCurrentOptions = state => {
  const { selectedSort: sortingOption } = state;
  const queryFragment = fromFilters.getAppliedFacetsForURLHash(state.filters);
  const sortFragment = sortingOption ? `&sort=${sortingOption}` : '';
  return encodeURI(`${queryFragment}${sortFragment}`);
};
